import React, { Component } from 'react';
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
import { GLOBAL, PREFERRED_COUNTRIES } from '../../../utils/Constants';
import LabelR from '../../Simple/LabelR';

class TelInput extends Component {
  constructor(props) {
    super(props);

    const { field: { value } = props } = props;
    this.state = {
      telInputValue: value,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { field: { value } = nextProps } = nextProps;
    if (value !== '' && value !== GLOBAL.INVALID) this.setState({ telInputValue: value });
  }

  handlePhoneChange = (status, value, countryData, number) => {
    let isValid = status;
    
    if (countryData.iso2 === 'ci' && value) {
      const numericValue = value.replace(/\D/g, '');
    
      if (/^225\d{8,10}$/.test(numericValue)) {
        isValid = true;
      }
    }    

    if (countryData.iso2 === 'ph' && value) {
      const numericValue = value.replace(/\D/g, '');
      isValid = /^(09|\+639)?\d{9}$/.test(numericValue) || /^\d{2,3}\d{7,8}$/.test(numericValue);
    }
    this.setState({ telInputValue: value });
    return isValid ? number : GLOBAL.INVALID;
  };

  render() {
    const {
      field: { name } = this.props,
      form: { touched, setFieldTouched, setFieldValue, errors },
      label,
      t,
      required,
      requiredFields,
      disabled,
      defaultCountry,
      allowDropdown,
      preferredCountries = PREFERRED_COUNTRIES,
      ...restProps
    } = this.props;

    const { telInputValue } = this.state;
    return (
      <div className="form-group" id={`${name}-container-input`}>
        {label &&
          (required ? (
            <LabelR requiredFields={requiredFields} isEditable={!disabled} htmlFor={name} name={name}>
              {label}
            </LabelR>
          ) : (
            <label htmlFor={name} id={`${name}-label`}>
              {label}
            </label>
          ))}
        <IntlTelInput
          format
          value={telInputValue}
          disabled={disabled}
          fieldId={`${name}-input`}
          fieldName={name}
          autoHideDialCode
          onPhoneNumberBlur={() => {
            setFieldTouched(name, true);
          }}
          css={['intl-tel-input', `form-control ${touched[name] && errors[name] ? 'is-invalid' : ''}`]}
          style={{
            display: 'block',
            width: '100%',
          }}
          onPhoneNumberChange={(status, value, countryData, number) => {
            setFieldValue(name, this.handlePhoneChange(status, value, countryData, number));
          }}
          preferredCountries={preferredCountries}
          defaultCountry={defaultCountry}
          allowDropdown={allowDropdown}
          {...restProps}
        />
        {touched[name] && errors[name] && <div className="invalid-feedback">{t(errors[name])}</div>}
      </div>
    );
  }
}

export default TelInput;
